export const discriminatedStringUnionIncludes = <T extends string>(arr: T[] | readonly T[], val: T | string): boolean =>
  arr.includes(val as T);
